import "./maintenance-banner.css";

import React from "react";
import { useIntl } from "react-intl";

import desktopJpg from "~/assets/img/maintenance/maintenance-desktop.jpg";
import desktopWebp from "~/assets/img/maintenance/maintenance-desktop.webp";
import mobileJpg from "~/assets/img/maintenance/maintenance-mobile.jpg";
import mobileWebp from "~/assets/img/maintenance/maintenance-mobile.webp";

export function MaintenanceBanner() {
  const intl = useIntl();

  return (
    <div className="maintenance-banner">
      <picture>
        <source media="(min-width: 900px)" srcSet={desktopWebp} type="image/webp" />
        <source media="(min-width: 900px)" srcSet={desktopJpg} type="image/jpeg" />
        <source srcSet={mobileWebp} type="image/webp" />
        <img src={mobileJpg} alt={intl.formatMessage({ id: "maintenance.heading" })} />
      </picture>
    </div>
  );
}
